import * as PropTypes from 'prop-types';
import * as React from 'react';
import { StickyScript } from './StickyScript.js';

var Sticky = props => {
  var {
    children
  } = props;
  var hcid = "".concat(Sticky.name.toLocaleLowerCase(), "-").concat("10.6.2");
  if (window.CSS && CSS.supports('position', 'sticky')) {
    return /*#__PURE__*/React.createElement("div", {
      className: "sticky-top",
      "data-hcid": hcid
    }, children);
  }
  // For browser witch do not support position: sticky
  return /*#__PURE__*/React.createElement(StickyScript, null, children);
};
Sticky.propTypes = {
  children: PropTypes.element.isRequired
};

export { Sticky };
